module.exports = __webpack_public_path__ + "static/media/Notification.608ee4ca.mp3";